import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-result" }

import { PropType } from 'vue';
import { Result } from '@/models/results.model';
import { Expense } from '@/models/expense';
import { formatCurrency } from '@/filters/filters';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExpenseSearchResult',
  props: {
  result: {
    type: Object as PropType<Result<Expense>>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: `/balance/expense/${__props.result.item.number}`
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.result.item.number), 1)
      ]),
      _: 1
    }, 8, ["to"]),
    _cache[0] || (_cache[0] = _createTextVNode(" (expense) ", -1)),
    _createElementVNode("div", null, _toDisplayString(__props.result.item.lines[0].description) + " " + _toDisplayString(_unref(formatCurrency)(new (_unref(Expense))(__props.result.item).total)), 1)
  ]))
}
}

})